const obj = {
  title: "почему VISION?".toUpperCase(),
  text1: {
    regular:
      "Vision — это ответ комьюнити на растущий натиск на нас. Это решение, которое поможет нам всем противостоять любым ".toUpperCase(),
    bold: "банам, удалениям и давлению, направленным против нас. ".toUpperCase(),
  },
  text2: {
    regular:
      "Как они могут стереть нас, если мы ежедневно отслеживаем и обновляем информацию о всем комьюнити?".toUpperCase(),
    bold: "Это невозможно.".toUpperCase(),
  },
  text3: "Vision — это ещё и способ защитить комьюнити от низкосортных и мегрельских проектов.".toUpperCase(),
  text4:
    "Заметили, как когда-то реальные чаты для заработка скатились в детский сад для школьников и солевых?".toUpperCase(),
  text5:
    "А ботофермы в чатах и на форумах? Это финальный гвоздь в крышку гроба доверия. Они убивают репутацию старичков и превращают комьюнити в дешёвый цирк.".toUpperCase(),
  text6:
    "на Vision мы объединяем как проверенную временем классику, так и амбициозные новые проекты с огромным потенциалом.".toUpperCase(),
  text7:
    "Мы верим в то, что мы все ещё можем восстановить сообщество и сделать его сильнее, чем когда-либо.".toUpperCase(),
  we_are_the: "мы - это".toUpperCase(),
  text8:
    "Наша миссия — сделать комьюнити сильнее, а каждого участника богаче, чем когда-либо. Все сообщество будет объединено в единую сеть для заработка.".toUpperCase(),
  text9:
    "Мы открыты к сотрудничеству с теми, у кого мощная репутация и есть действительно стоящие предложения.".toUpperCase(),
}

const formatted = obj
export default formatted
